import { useMemo } from "react";
import { useCurrencyRatesQuery } from "../gql";

export type CurrencyRateRow = { currency: string; rate: number };

/**
 * Hourly FX rates for converting SEK catalog prices to the floorplan display currency.
 */
export function useCurrencyRates() {
  const { data, loading, error } = useCurrencyRatesQuery({
    fetchPolicy: "cache-first",
  });

  const ratesArray = useMemo<CurrencyRateRow[]>(() => {
    return data?.currencyRates?.rates ?? [];
  }, [data?.currencyRates?.rates]);

  return {
    ratesArray,
    base: data?.currencyRates?.base ?? null,
    lastUpdated: data?.currencyRates?.lastUpdated ?? null,
    loading,
    error,
  };
}
